export default "__VITE_ASSET__BPwuhZ4C__"